import React, { Component } from 'react';
import { FaTicketAlt, FaExchangeAlt } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setProspecto } from '~/Store/Prospecto/actions';
import Outsider from '../../Outsider';
import { Formik } from 'formik';
import {
  vincularSenhaLancamento,
  alterarAtendimentoPreferencial,
} from '../../../Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { SEGUNDO_EMPREENDIMENTO_LANCAMENTO } from '~/constant';

class VinculadorSenhaLancamento extends Component {
  state = {
    isEditandoSenha: false,
    isVinculando: false,
    isSucesso: null,
    isError: null,
    isModalMarreta: false,
    justificativa: '',
  };

  editarSenha = isEditandoSenha => {
    this.setState({ isEditandoSenha });
  };

  errorEnum = {
    ERRO_SENHA_EM_USO: 'Senha já está em uso',
    ERRO_NENHUM_LANCAMENTO_ATIVO:
      'Nenhum empreendimento em lançamento no momento',
    ERRO_DESCONHECIDO: 'Erro desconhecido',
  };

  mensagens = {
    SENHA_VINCULADA: 'Senha vinculada com sucesso',
    SENHA_ATUALIZADA: 'Senha alterada com sucesso',
    VERIFICADO_LANCAMENTO: 'O cliente optou por contrato digital.',
    SENHA_JA_VINCULADA: 'Senha alterada com sucesso',
    ERRO_SENHA_EM_USO: 'Senha em uso!',
    ERRO_NENHUM_LANCAMENTO_ATIVO: 'Nenhum lançamento ativo!',
    ERRO_DESCONHECIDO: 'Erro desconhecido! Comunique a TI!',
  };

  timeout = null;

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  setErrorVinculando = isError => {
    this.setState({
      isError,
    });
  };

  onClickVincularSenha = ({ codigo_prospecto, senha, codigo_familia }) => {
    this.setState({
      isVinculando: true,
      isSucesso: null,
      isError: null,
    });

    let request = {
      codigo_prospecto,
      senha: parseInt(senha),
      codigo_familia,
      sem_nivel: this.props.modoAssinatura ? true : false,
    };

    return vincularSenhaLancamento(request)
      .then(response => {
        var mensagem = this.mensagens[response.message];

        if (!mensagem.includes('erro')) {
          this.props.setProspecto('senha', senha);
          if (response.atendimento_preferencial != null) {
            this.props.setProspecto(
              'atendimento_preferencial',
              response.atendimento_preferencial
            );
          }
        }

        this.setState({
          isVinculando: false,
          isSucesso: mensagem,
          isEditandoSenha: false,
        });

        this.timeout = setTimeout(() => {
          this.setState({
            isSucesso: null,
          });
        }, 5000);
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isVinculando: false,
          isError: this.errorEnum[error.message],
        });
      });
  };

  abrirModalMarreta = () => {
    this.setState({ isModalMarreta: true, justificativa: '' });
  };

  fecharModalMarreta = () => {
    this.setState({ isModalMarreta: false, justificativa: '' });
  };

  confirmarAlterarNivel = () => {
    const { prospecto } = this.props;
    const { justificativa } = this.state;
    const isDiamante = prospecto.atendimento_preferencial === true;

    this.setState({ isVinculando: true, isModalMarreta: false });

    alterarAtendimentoPreferencial({
      codigo_prospecto: prospecto.codigo,
      codigo_familia: prospecto.codigo_familia,
      atendimento_preferencial: !isDiamante,
      justificativa: justificativa,
    })
      .then(response => {
        this.props.setProspecto('atendimento_preferencial', !isDiamante);
        if (response && response.nova_senha > 0) {
          this.props.setProspecto('senha', response.nova_senha);
        }
        this.setState({
          isVinculando: false,
          justificativa: '',
        });
        toast.success('Nível alterado com sucesso');
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isVinculando: false,
          justificativa: '',
        });
        toast.error('Erro ao alterar nível');
      });
  };

  render() {
    const { prospecto, configuracaoLancamento } = this.props;
    const { codigo_familia, senha, codigo } = prospecto;
    const { isEditandoSenha, isVinculando, isSucesso, isError, isModalMarreta, justificativa } = this.state;
    const possuiSenha = senha != null && senha !== '' && !isNaN(parseInt(senha, 10));

    // Se já tem valor gravado (boolean, após vincular senha ou marreta), usa ele.
    // Senão, calcula preview baseado nas condições atuais do prospecto.
    // Nota: nullPropertiesToString converte null para '' no Redux,
    // então verificamos typeof boolean para saber se é um valor real.
    var isDiamante;
    if (typeof prospecto.atendimento_preferencial === 'boolean') {
      isDiamante = prospecto.atendimento_preferencial === true;
    } else {
      var temDocCompleta = prospecto.documentacao_completa === true;
      var rendaPessoal = parseFloat(prospecto.renda_pessoal) || 0;
      var rendaFamiliar = parseFloat(prospecto.renda_familiar) || 0;
      isDiamante = temDocCompleta && (rendaPessoal > 0 || rendaFamiliar > 0);
    }

    const empreendimentoLancamento = configuracaoLancamento
      ? configuracaoLancamento.empreendimento
      : 0;

    const isLancamento =
      empreendimentoLancamento > 0 &&
      (codigo_familia === empreendimentoLancamento ||
        codigo_familia === SEGUNDO_EMPREENDIMENTO_LANCAMENTO);

    if (isLancamento) {
      return (
        <Outsider
          onClickOut={() => {
            if (!isVinculando) {
              this.editarSenha(false);
            }
          }}
        >
          <div className="VinculadorSenhaLancamento d-flex align-items-center">
            {isEditandoSenha ? (
              <Formik
                initialValues={{ senha, codigo_familia }}
                onSubmit={values =>
                  this.onClickVincularSenha({
                    ...values,
                    codigo_prospecto: codigo,
                  })
                }
                validate={values => {
                  let errors = {};

                  if (isError) this.setErrorVinculando(false);

                  if (!values.senha) {
                    errors.senha = 'Informe uma senha';
                  } else if (isNaN(parseInt(values.senha))) {
                    errors.senha = 'Senha inválida';
                  }

                  return errors;
                }}
              >
                {({ handleSubmit, handleChange, values, errors }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="form-row align-items-center">
                      <div className="col-auto">
                        <input
                          required
                          type="tel"
                          className={
                            (errors.senha ? 'is-invalid ' : '') +
                            'form-control form-control-sm'
                          }
                          disabled={isVinculando}
                          onChange={e => {
                            let valor = e.target.value;
                            if (valor.length <= 4 && /^\d*$/.test(valor)) {
                              handleChange(e);
                            }
                          }}
                          autoFocus
                          value={values.senha}
                          id="senha"
                          name="senha"
                          placeholder="Ex.: 77"
                        />
                      </div>
                      <div className="col-auto">
                        <button
                          type="submit"
                          disabled={isVinculando}
                          className="btn btn-outline-secondary btn-sm"
                        >
                          {isVinculando ? 'Vinculando...' : 'Vincular'}
                        </button>
                      </div>
                    </div>
                    {errors.senha && (
                      <small className="text-danger">{errors.senha}</small>
                    )}
                    {isError && (
                      <small className="text-danger">{isError}</small>
                    )}
                  </form>
                )}
              </Formik>
            ) : (
              <div className="d-flex align-items-center">
                {isSucesso && (
                  <small className="text-success mr-2">{isSucesso}</small>
                )}
                <button
                  className={
                    this.props.modoAssinatura
                      ? 'btn btn-secondary'
                      : isDiamante
                        ? 'btn btn-diamante'
                        : 'btn btn-topazio'
                  }
                  type="button"
                  onClick={() => this.editarSenha(true)}
                  title={this.props.modoAssinatura ? 'Sem nível' : isDiamante ? 'Diamante' : 'Topázio'}
                >
                  <span>
                    <FaTicketAlt />
                    &nbsp;
                    {senha ? senha : 'Vincular Senha'}
                  </span>
                </button>
                {possuiSenha &&
                  AuthStorage.temCaracteristicas([606]) && (
                    <button
                      className="btn btn-outline-secondary btn-sm ml-1"
                      type="button"
                      title="Alterar nível Diamante/Topázio"
                      onClick={this.abrirModalMarreta}
                      disabled={isVinculando}
                    >
                      <FaExchangeAlt />
                    </button>
                  )}
              </div>
            )}
          </div>
          <Modal show={isModalMarreta} onHide={this.fecharModalMarreta} centered>
            <Modal.Header closeButton>
              <Modal.Title>
                Alteração de Nível ({isDiamante ? 'Diamante → Topázio' : 'Topázio → Diamante'})
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Label>Justificativa</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={justificativa}
                  onChange={e => this.setState({ justificativa: e.target.value })}
                  placeholder="Informe a justificativa para alteração de nível"
                  autoFocus
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={this.fecharModalMarreta}>
                Cancelar
              </Button>
              <Button
                variant="primary"
                disabled={!justificativa.trim()}
                onClick={this.confirmarAlterarNivel}
              >
                Confirmar
              </Button>
            </Modal.Footer>
          </Modal>
        </Outsider>
      );
    }

    return null;
  }
}

const mapStateToProps = state => ({
  prospecto: state.prospecto.detail,
  configuracaoLancamento: state.options.configuracaoLancamento,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setProspecto,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VinculadorSenhaLancamento);
